import React from 'react';
import { css } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import { Button, ButtonAppearance } from '@atlassian/learning-components';
import { NotFound } from 'assets/images';
import { useRouter } from 'react-resource-router';

export const NotFoundPage: React.FC = () => {
  const [, { push }] = useRouter();

  return (
    <div css={pageStyles}>
      <div css={containerStyles}>
        <img src={NotFound} alt="Error" css={dangerTriangleStyles} />
        <h1 css={headingStyles}>Invalid Path</h1>
        <p css={descriptionStyles}>This path does not exist</p>
        <Button label="Go home" appearance={ButtonAppearance.LINK} onClick={() => push('/')} />
      </div>
    </div>
  );
};

export default NotFoundPage;

const containerStyles = css({
  maxWidth: '800px',
  minWidth: '375px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: token('space.600'),
});

const dangerTriangleStyles = css({
  marginBottom: token('space.300'),
});

const headingStyles = css({
  marginBottom: token('space.200'),
  fontFamily: token('font.family.brand.heading'),
  fontSize: '24px',
  fontWeight: token('font.weight.semibold'),
  lineHeight: '32px',
  textAlign: 'center',
});

const descriptionStyles = css({
  marginBottom: token('space.200'),
  color: token('color.text'),
  fontFamily: 'Inter',
  fontWeight: '400',
  lineHeight: '20px',
  textAlign: 'center',
  fontSize: '16px',
});

const pageStyles = css({
  display: 'flex',
  width: '100%',
  flexDirection: 'column',
  alignItems: 'center',
  paddingBottom: token('space.800'),
});
